import $ from 'jquery'
// import Swiper JS
import Swiper, { Navigation } from 'swiper'

Swiper.use([Navigation])

$(document).ready(dhsv_vc_icon_block())

function dhsv_vc_icon_block() {
  jQuery('.trainer-modal').closest('section.vc_section').css('z-index', 'unset')

  new Swiper('.teaser-slider', {
    speed: 400,
    loop: true,
    spaceBetween: 0,
    slidesPerView: 4,
    observer: true,
    observeParents: true,
    watchOverflow: true,
    modules: [Navigation],
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      325: {
        slidesPerView: 1,
      },
      480: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
      1025: {
        slidesPerView: 4,
      },
      1550: {
        slidesPerView: 4,
      },
    },
  })
}
